import { render, staticRenderFns } from "./ProductionsCreate.vue?vue&type=template&id=46035162"
import script from "./ProductionsCreate.vue?vue&type=script&lang=js"
export * from "./ProductionsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports